// extracted by mini-css-extract-plugin
export default {"cardGroupsContainer":"DiscoverSubCategories_cardGroupsContainer__oZZxx"};